import { Attrs, EventListeners, MinzeElement } from "minze";

export interface TjPopupForm {
  dataModalId: string;
  dataButtonLabel: string;
  dataButtonSize: string;
}

export class TjPopupForm extends MinzeElement {
  attrs: Attrs = ["data-modal-id", "data-button-label", "data-button-size"];

  openModal() {
    const mainModule = window.TJ_MAIN_MODULE;
    mainModule.showModal(this.dataModalId);
  }

  html = () => /* html */ `
    <tj-button size="${this.dataButtonSize}" id="open-modal" class="${this.dataModalId}-open-button">${this.dataButtonLabel}</tj-button>
    <tj-modal modal-id="${this.dataModalId}">
      <div slot="tj-modal-content">
        <slot name="tj-content"></slot>
      </div>
    </tj-modal>
  `;

  css = () => `
    tj-background-arrow-icon {
      position: absolute;
      top: 0;
      left: 0;
    }
  `;

  eventListeners: EventListeners = [
    ["#open-modal", "click", this.openModal.bind(this)],
  ];
}
